import React from 'react';
import { ToastComponent as ToastComponentNew } from './Toast';
import { convertOldToastProps } from './converter.old';
import type { OldToastComponentProps } from './converter.old';

export type ToastComponentProps = OldToastComponentProps;

export const ToastComponent: React.FC<ToastComponentProps> = (props) => (
  <ToastComponentNew {...convertOldToastProps(props)} />
);
